import { __extends } from 'tslib';
import React__default, { createRef } from 'react';
import { propTypes } from './ScrollNavSection.types.js';
import { ScrollNavContext } from './ScrollNav.utils.js';
import styles from './ScrollNav.module.scss.js';

var ScrollNavSection = /** @class */ (function (_super) {
    __extends(ScrollNavSection, _super);
    function ScrollNavSection(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = createRef();
        return _this;
    }
    ScrollNavSection.prototype.componentDidMount = function () {
        if (this.ref.current) {
            this.context.observe(this.ref.current, this.props.id, this.props.title, this.props.testId);
        }
    };
    ScrollNavSection.prototype.render = function () {
        var _a = this.props, children = _a.children, id = _a.id, className = _a.className, testId = _a.testId;
        return (React__default.createElement("div", { id: id, ref: this.ref, className: styles.ScrollNavSection + " " + (className || ''), "data-testid": testId }, children));
    };
    ScrollNavSection.displayName = 'ScrollNav.Section';
    ScrollNavSection.propTypes = propTypes;
    ScrollNavSection.contextType = ScrollNavContext;
    return ScrollNavSection;
}(React__default.Component));

export { ScrollNavSection as default };
